// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"7":"restaurant","213":"imprint","296":"privacy","449":"notFound","508":"offer"}[chunkId] + "." + {"7":"d0407dc7","213":"c6646daf","296":"6cb86543","449":"bf089fc4","508":"0b2ac999"}[chunkId] + ".js";
};